import React from 'react';
import ArticleGroupDetailContainer from '@src/containers/ArticleGroupDetail';

const SpecialGroupDetail = () => <ArticleGroupDetailContainer />;

export default SpecialGroupDetail;
